module.exports = __webpack_public_path__ + "img/pic_3.2e797dc0.jpg";